export function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const base64 = reader.result.split(",")[1] // Remove data URL prefix
      resolve(base64)
    }
    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })
}

export const validateImageFile = (file, type, width, height, maxSizeMB) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(true)
      return
    }

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"]
    if (!allowedTypes.includes(file.type)) {
      reject(
        new Error(
          `Invalid file type for ${type}. Only JPEG and PNG are allowed.`
        )
      )
      return
    }

    const maxSizeBytes = maxSizeMB * 1024 * 1024
    if (file.size > maxSizeBytes) {
      reject(
        new Error(
          `File size too large for ${type}. Maximum ${maxSizeMB}MB allowed.`
        )
      )
      return
    }

    const img = new Image()
    img.onload = function () {
      if (img.width !== width || img.height !== height) {
        reject(
          new Error(
            `Invalid resolution for ${type}. Expected ${width}x${height}, got ${img.width}x${img.height}.`
          )
        )
        return
      }
      resolve(true)
    }

    img.onerror = function () {
      reject(
        new Error(`Invalid image file for ${type}. File may be corrupted.`)
      )
    }

    img.src = URL.createObjectURL(file)
  })
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}
